import React, { forwardRef } from 'react'

import classNames from 'classnames'
import {
  BeautifulMentionsMenuItemProps,
  BeautifulMentionsMenuProps,
  BeautifulMentionsTheme,
} from 'lexical-beautiful-mentions'
import { UserCircleIcon } from '@heroicons/react/20/solid'

export const mentionsTheme: BeautifulMentionsTheme = {
  '@': {
    trigger: 'text-sky-700',
    value: 'text-sky-700',
    container: 'bg-yellow-100 px-1 rounded',
    containerFocused: 'bg-yellow-200 px-1 rounded',
  },
}

export const MentionsMenu = ({ ...props }: BeautifulMentionsMenuProps) => (
  <ul
    className='w-max bg-white border rounded-lg shadow-md overflow-hidden'
    {...props}
  />
)

export const MentionsMenuItem = forwardRef<HTMLLIElement, BeautifulMentionsMenuItemProps>(
  ({ selected, item, ...props }, ref) => (
    <li
      ref={ref}
      className={classNames('px-3 py-1.5 flex gap-1 items-center', {
        'bg-blue-500 text-white': selected,
      })}
      {...props}
    >
      <UserCircleIcon
        width={20}
        height={20}
      />
      <span className='text-sm'>{item.value}</span>
    </li>
  )
)

MentionsMenuItem.displayName = 'MentionsMenuItem'
